export enum OrdenEstado {
  Borrador,
  Anulada,
  Recibida,
  Planificada,
  Produccion,
  Terminada,
  Controlada,
  Despachada,
  Rechazada,
  Finalizada,
}

export const OrdenEstadoLabels: { [key in OrdenEstado]: string } = {
  [OrdenEstado.Borrador]: 'Borrador',
  [OrdenEstado.Anulada]: 'Anulada',
  [OrdenEstado.Recibida]: 'Recibida',
  [OrdenEstado.Planificada]: 'Planificada',
  [OrdenEstado.Produccion]: 'En Producción',
  [OrdenEstado.Terminada]: 'Terminada',
  [OrdenEstado.Controlada]: 'Controlada',
  [OrdenEstado.Despachada]: 'Despachada',
  [OrdenEstado.Rechazada]: 'Rechazada',
  [OrdenEstado.Finalizada]: 'Finalizada',
};

export const getOrdenEstado = () => {
  return Object.values(OrdenEstado)
    .filter((value) => typeof value === 'number')
    .map((id) => ({
      id,
      text: OrdenEstadoLabels[id as OrdenEstado],
    }));
};

export const colorMapping: { [key in OrdenEstado]: string } = {
  [OrdenEstado.Borrador]: '#70BDFF',
  [OrdenEstado.Planificada]: '#FFC300',
  [OrdenEstado.Produccion]: '#FF5733',
  [OrdenEstado.Terminada]: '#C70039',
  [OrdenEstado.Controlada]: '#8adf75',
  [OrdenEstado.Despachada]: '#70c75e',
  [OrdenEstado.Recibida]: '#57af47',
  [OrdenEstado.Finalizada]: '#237e18',
  [OrdenEstado.Rechazada]: '#FF0000',
  [OrdenEstado.Anulada]: 'black',
};
